<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="年月">
              <el-select v-model="q.yearMonth" placeholder="请选择" clearable style="width:100%">
                <el-option v-for="item in yearMonthList" :key="item" :label="item" :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="出入库">
              <el-select v-model="q.inOutFlag" placeholder="请选择" clearable style="width:100%">
                <el-option label="入库" :value="1"/>
                <el-option label="出库" :value="2"/>
                <el-option label="线下出库" :value="3"/>
              </el-select>
            </el-form-item>
            <el-form-item label="平台商编码/名称">
              <el-input v-model="q.ptCodeName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料编码/名称">
              <el-input v-model="q.materialCodeName" placeholder="请输入" clearable/>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="订单号">
                  <el-input v-model="q.sapCode" placeholder="请输入" clearable/>
                </el-form-item>
                <el-form-item label="售达方编码/名称">
                  <el-input v-model="q.soldToCodeName" placeholder="请输入" clearable/>
                </el-form-item>
              </div>
            </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" @click="handleSync" v-if="isAdmin">重新计算</el-button>
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table
            :data="tableData"
            ref="multipleTable"
            stripe border
            style="width: 100%"
            max-height="450"
        >
          <el-table-column prop="yearMonth" label="年月" width="70" show-overflow-tooltip/>
          <el-table-column prop="ptName" label="平台商名称" width="160" show-overflow-tooltip/>
          <el-table-column prop="materialCode" label="物料编码" width="90" show-overflow-tooltip/>
          <el-table-column prop="materialName" label="物料名称" width="150" show-overflow-tooltip/>
          <el-table-column prop="inOutFlag" label="出入库" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.inOutFlag === 1">入库</span>
              <span v-else-if="scope.row.inOutFlag === 2">出库</span>
              <span v-else-if="scope.row.inOutFlag === 3">线下出库</span>
              <span v-else>{{scope.row.inOutFlag}}</span>
            </template>
          </el-table-column>
          <el-table-column label="出入库日期" width="100">
            <template slot-scope="scope">
              {{ scope.row.inOutDate ? scope.row.inOutDate.substring(0, 10) : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="proNumber" label="数量" width="70" show-overflow-tooltip/>
          <el-table-column prop="unitPrice" label="单价" width="80"/>
          <el-table-column prop="amount" label="金额" width="100"/>
          <el-table-column prop="sapCode" label="订单号" width="100" show-overflow-tooltip/>
          <el-table-column prop="firstSapCode" label="关联订单号" width="100" show-overflow-tooltip/>
          <el-table-column prop="receivingUnit" label="收货单位" width="150" show-overflow-tooltip/>
          <el-table-column prop="soldToCode" label="售达方编码" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.inOutFlag === 2">{{scope.row.soldToCode}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="soldToName" label="售达方名称" width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.inOutFlag === 2">{{scope.row.soldToName}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableBL">
          <el-button class="h-btn h-formBtn h-bgblueQ" @click="exportExcel">批量导出</el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="q" @query="query"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "@/api/SystemService";
import updownfile from "@/utils/updownfile";

export default {
  data() {
    return {
      q: {
        yearMonth: '',
        inOutFlag: null,
        ptCodeName: '',
        materialCodeName: '',
        sapCode: '',
        soldToCodeName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      yearMonthList: [],
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters.hasRole('swyl_admin');
    }
  },
  methods: {
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    handleFilter() {
      this.q.pageNo = 1
      this.query()
    },
    resetData() {
      this.q = {
        yearMonth: '',
        inOutFlag: null,
        ptCodeName: '',
        materialCodeName: '',
        sapCode: '',
        soldToCodeName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.query()
    },
    query() {
      let params = { ...this.q }
      // 平台商编码/名称 联合搜索 → ptKeyword
      if (params.ptCodeName) {
        params.ptKeyword = params.ptCodeName
      }
      // 物料编码/名称 联合搜索 → materialKeyword
      if (params.materialCodeName) {
        params.materialKeyword = params.materialCodeName
      }
      // 售达方编码/名称 联合搜索 → soldToKeyword
      if (params.soldToCodeName) {
        params.soldToKeyword = params.soldToCodeName
      }
      ss.bscHhptInventoryRecord.selectRecordPage(params).then(res => {
        this.tableData = res.records;
        this.q.total = res.total;
      })
    },
    handleSync() {
      this.$confirm('确定要同步出入库记录吗？同步后将更新对应月份的报表。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.bscHhptInventoryRecord.syncInventoryRecords().then(res => {
          if (res.f) {
            this.$message.success('同步成功');
            this.query();
            this.getYearMonths();
          }
        })
      }).catch(() => {});
    },
    exportExcel() {
      let params = { ...this.q }
      if (params.ptCodeName) {
        params.ptKeyword = params.ptCodeName
      }
      if (params.materialCodeName) {
        params.materialKeyword = params.materialCodeName
      }
      if (params.soldToCodeName) {
        params.soldToKeyword = params.soldToCodeName
      }
      updownfile.down("/api/swyl/v1/inventoryReport/bscHhptInventoryRecord/downloadExcel", params, "get");
    },
    initFromRoute() {
      const { yearMonth, ptCode, materialCode } = this.$route.query;
      if (yearMonth) this.q.yearMonth = yearMonth;
      if (ptCode) this.q.ptCodeName = ptCode;
      if (materialCode) this.q.materialCodeName = materialCode;
    },
    getYearMonths() {
      ss.bscHhptInventoryRecord.getYearMonths().then(res => {
        if (res.f) {
          this.yearMonthList = res.obj || [];
        }
      })
    },
  },
  created() {
    this.initFromRoute();
    this.getYearMonths();
    this.query();
  },
  activated() {
    this.initFromRoute();
    this.query()
  }
}
</script>
<style lang="less" scoped>
</style>
